import React, { FC } from 'react';
import { Paper } from '@lifeomic/chroma-react/components/Paper';
import BrandedBackground from '../../common/BrandedBackground';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { LinearProgress } from '@lifeomic/chroma-react/components/LinearProgress';
import { FLGrayStacked } from '@lifeomic/phc-web-toolkit/src/components/Logos';

const useStyles = makeStyles(() => ({
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  layout: {
    '& > svg': {
      position: 'absolute',
    },
  },
  paper: {
    animation: '$fadeIn 0.5s',
    borderRadius: 15,
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    padding: 64,
    height: 290,
    width: 380,
    maxWidth: '80%',
    minWidth: 150,
    zIndex: 1,
  },
  logo: {
    flex: 1,
    width: 175,
  },
  linearProgress: {
    '--linear-progress-height': '0.5rem',
    width: '100%',
    borderRadius: '0.25rem',
    '& > div': {
      borderRadius: '0.25rem',
    },
  },
}));

interface Props {
  text?: string;
}

const LoadingViewComponent: FC<Props> = ({ text }: Props) => {
  const classes = useStyles({});

  return (
    <BrandedBackground className={classes.layout}>
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <FLGrayStacked className={classes.logo} />
          {text && <Text>{text}</Text>}
          <LinearProgress
            className={classes.linearProgress}
            variant="indeterminate"
          />
        </Paper>
      </div>
    </BrandedBackground>
  );
};

LoadingViewComponent.displayName = 'LoadingViewComponent';
export default LoadingViewComponent;
